import Vue from "vue";
//import Vuetify from "vuetify";
import Vuetify from 'vuetify/lib'
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition';

const fadeTransition = createSimpleTransition('callout-transition')
Vue.component('callout-transition', fadeTransition)

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            dark: {
                primary: "#9584FF",
                secondary: "#715BF7",
                accent: "#256FEB",
                error: "#ec0f0f",
                background: "#333333"
            },
            light: {
                primary: "#715BF7",
                secondary: "#5642CC",
                accent: "#256FEB",
                error: "#b71c1c",
                background: "#eeeeee"
            },

        }
    }
});
